export enum SortRepairRequestColumnsEnum {
  CREATED_AT = "createdAt",
  NAME = "sportEquipment.name",
  INVENTORY_NUMBER = "sportEquipment.inventoryNumber",
  TECHNICAL_CONDITION = "sportEquipment.technicalCondition",
  EQUIPMENT_TYPE = "sportEquipment.equipmentType",
  COMMISSIONING_DATE = "sportEquipment.commissioningDate",
  SPORT_ZONE = "sportEquipment.sportZone.name",
  SPORT_OBJECT = "sportEquipment.sportObject.name",
  SPORT_SUBZONE = "sportEquipment.sportSubZone.name",
  STATE_HISTORY_STATUS = "stateHistory.status",
  SPORT_KIND = "sportEquipment.sportKindObject.name",
}